import "./style/w3.css";
import "./style/styles.css";

import {
  ErrorBoundary,
  LocationProvider,
  Route,
  Router,
  lazy,
  prerender as ssr,
} from "preact-iso";
import { hydrate } from "preact";

import SiteHeader from "./components/SiteHeader";
import Footer from "./components/Footer";
import { getSchoolDetails, handlePromise } from "./utilities";
import { API_URL } from "./constants";

const Signup = lazy(() => import("./pages/Signup"));
const Order = lazy(() => import("./pages/Order"));
const Paid = lazy(() => import("./pages/Paid"));
const _404 = lazy(() => import("./pages/_404"));
const New = lazy(() => import("./pages/New"));

export function App(props: any) {
  return (
    <>
      <LocationProvider>
        <ErrorBoundary>
          <SiteHeader />
          <main>
            <Router>
              <Route
                path="/"
                component={Signup}
                staticTermOptions={props.staticTermOptions}
              />
              <Route
                path="/mcgill"
                component={Signup}
                staticTermOptions={props.staticTermOptions}
              />
              <Route path="/order" component={Order} />
              <Route path="/paid" component={Paid} />
              <Route path="/new" component={New} />
              <Route default component={_404} />
            </Router>
          </main>
          <Footer />
        </ErrorBoundary>
      </LocationProvider>
    </>
  );
}

if (typeof window !== "undefined") {
  hydrate(<App />, document.getElementById("app"));
}

export async function prerender(data: any) {
  if (data.url === "/order") {
    const { html, links } = await ssr(<App {...data} />);
    return { html, links, head: { title: "Order - Seat Alert" } };
  }
  if (data.url === "/paid") {
    const { html, links } = await ssr(<App {...data} />);
    return {
      html,
      links,
      head: {
        title: "Why is Seat Alert Paid? - Seat Alert",
        elements: new Set([
          {
            type: "meta",
            props: {
              name: "robots",
              content: "noindex",
            },
          },
        ]),
      },
    };
  }
  if (data.url === "/new") {
    const { html, links } = await ssr(<App {...data} />);
    return {
      html,
      links,
      head: {
        title: "What's new - Seat Alert",
        elements: new Set([
          {
            type: "meta",
            props: {
              name: "robots",
              content: "noindex",
            },
          },
        ]),
      },
    };
  }
  if (data.url === "/404") {
    const { html, links } = await ssr(<App {...data} />);
    return { html, links, head: { title: "404 Not Found - Seat Alert" } };
  }

  if (data.url === "/" || data.url === "/mcgill") {
    const SCHOOL_CONST = getSchoolDetails(data.url);
    const [result, error] = await handlePromise(
      fetch(`${API_URL}/${SCHOOL_CONST.SCHOOL}/terms`)
    );
    let staticTermOptions = [];
    if (error || !result.ok) {
      console.warn("FAILED TO GET TERMS FOR PRERENDER.");
    } else {
      staticTermOptions = await result.json();
    }
    const { html, links } = await ssr(<App {...{ data, staticTermOptions }} />);
    return {
      html,
      links,
      head: {
        title: `${SCHOOL_CONST.FULL_NAME} - Seat Alert`,
        elements: new Set([
          {
            type: "meta",
            props: {
              name: "theme-color",
              content: `${SCHOOL_CONST.COLOR}`,
            },
          },
          {
            type: "meta",
            props: {
              name: "description",
              content:
                "Sign up to get text & email alerts when seats become available in a full course",
            },
          },
        ]),
      },
    };
  }

  return await ssr(<App {...data} />);
}
